if (!customElements.get('players-filter')) {
  class PlayersFilter extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.pills = this.querySelectorAll('.players__filter-pill');
      this.items = this.querySelectorAll('.players__grid-item');
      this.pillsList = this.querySelector('.players__filter-pills');
      this.dragMoved = false;

      this.pills.forEach((pill) => {
        pill.addEventListener('click', this._onPillClick.bind(this, pill), { signal: this.controller.signal });
      });

      if (this.pillsList) {
        this._boundMouseDown = this._boundMouseDown || this._onMouseDown.bind(this);
        this._boundMouseMove = this._boundMouseMove || this._onMouseMove.bind(this);
        this._boundMouseUp = this._boundMouseUp || this._onMouseUp.bind(this);
        this._boundClickCapture = this._boundClickCapture || this._onClickCapture.bind(this);

        this.pillsList.addEventListener('mousedown', this._boundMouseDown, { signal: this.controller.signal });
        this.pillsList.addEventListener('click', this._boundClickCapture, { signal: this.controller.signal, capture: true });

        this._updateScrollable();

        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(() => this._updateScrollable());
          this.resizeObserver.observe(this.pillsList);
        }
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.dragController?.abort();
      this.resizeObserver?.disconnect();
    }

    _updateScrollable() {
      if (!this.pillsList) return;
      const isScrollable = this.pillsList.scrollWidth > this.pillsList.clientWidth;
      this.pillsList.classList.toggle('players__filter-pills--scrollable', isScrollable);
    }

    _onMouseDown(event) {
      if (event.button !== 0) return;
      if (!this.pillsList.classList.contains('players__filter-pills--scrollable')) return;

      this.startX = event.pageX;
      this.startScrollLeft = this.pillsList.scrollLeft;
      this.dragMoved = false;

      this.dragController = new AbortController();
      const signal = this.dragController.signal;
      document.addEventListener('mousemove', this._boundMouseMove, { signal });
      document.addEventListener('mouseup', this._boundMouseUp, { signal });
      document.addEventListener('mouseleave', this._boundMouseUp, { signal });
    }

    _onMouseMove(event) {
      const delta = event.pageX - this.startX;

      if (!this.dragMoved && Math.abs(delta) > 3) {
        this.dragMoved = true;
        this.pillsList.classList.add('players__filter-pills--dragging');
      }

      if (this.dragMoved) {
        event.preventDefault();
        this.pillsList.scrollLeft = this.startScrollLeft - delta;
      }
    }

    _onMouseUp() {
      this.pillsList.classList.remove('players__filter-pills--dragging');
      this.dragController?.abort();
    }

    _onClickCapture(event) {
      if (this.dragMoved) {
        event.preventDefault();
        event.stopPropagation();
        this.dragMoved = false;
      }
    }

    _onPillClick(pill) {
      const filterValue = pill.dataset.filterValue;

      this.pills.forEach((otherPill) => {
        const isActive = otherPill === pill;
        otherPill.classList.toggle('players__filter-pill--active', isActive);
        otherPill.setAttribute('aria-pressed', isActive);
      });

      this.items.forEach((item) => {
        if (filterValue === '') {
          item.style.display = '';
          return;
        }

        const itemFilters = item.dataset.filtro ? item.dataset.filtro.split('|') : [];
        item.style.display = itemFilters.includes(filterValue) ? '' : 'none';
      });
    }
  }

  customElements.define('players-filter', PlayersFilter);
}
